import React, { useState, useEffect, forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import { formatDateWbar } from "../../../../components/Util/DateFormat";
import { ko } from "date-fns/esm/locale";
import "./BbsVote.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquarePlus } from "@fortawesome/free-regular-svg-icons";
import { faSquareMinus } from "@fortawesome/free-regular-svg-icons";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";
import { faCalendarDays } from "@fortawesome/free-regular-svg-icons";
import { getServerBaseUrl } from "../../../../utils/portConfig";
import Swal from "sweetalert2";
import axios from "axios";

function BbsVote() {
  const initialVoteData = {
    title: "",
    startDate: "",
    endDate: "",
    enabled: true,
    multipleChoice: false,
    voteDetails: [],
  };
  const [voteData, setVoteData] = useState({ ...initialVoteData });
  const [isToggledDoubleCheck, setToggledDoubleCheck] = useState(false); //복수선택
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [options, setOptions] = useState([{ id: 1, placeholder: "옵션1", votes: 0 }]);
  const navigate = useNavigate();

  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1/vote`;
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userid");

  useEffect(() => {
    // startDate가 변경될 때마다 endDate 업데이트
    if (startDate) {
      const nextWeekDate = new Date(startDate);
      nextWeekDate.setDate(startDate.getDate() + 7);
      setEndDate(nextWeekDate);
    }
  }, [startDate]);

  // 초기에도 startDate 설정
  useEffect(() => {
    const initialStartDate = new Date();
    initialStartDate.setDate(initialStartDate.getDate() + 1);
    setStartDate(initialStartDate);
  }, []);

  const handleChange = (e, optionId) => {
    const { name, value } = e.target;
    if (name === "content") {
      //voteDetails에도 새로운 옵션 추가
      setVoteData((prevData) => ({
        ...prevData,
        voteDetails: prevData.voteDetails.map((detail) => (detail.id === optionId ? { ...detail, content: value } : detail)),
      }));
    } else {
      setVoteData({
        ...voteData,
        [name]: value,
      });
    }
  };

  const addOption = () => {
    const newOptionId = options.length > 0 ? options[options.length - 1].id + 1 : 1;
    const newOption = {
      id: newOptionId,
      placeholder: `옵션${newOptionId}`,
      votes: 0,
    };

    setOptions((prevOptions) => [...prevOptions, newOption]);
    // voteDetails에도 새로운 옵션 추가
    setVoteData((prevData) => ({
      ...prevData,
      voteDetails: [
        ...prevData.voteDetails,
        { content: "", id: newOption.id }, // 새로운 옵션의 ID를 추가
      ],
    }));
  };

  const removeOption = (id) => {
    setOptions((prevOptions) => prevOptions.filter((option) => option.id !== id));

    // 옵션 삭제 시 voteDetails에서도 해당 옵션 제거
    setVoteData((prevData) => ({
      ...prevData,
      voteDetails: prevData.voteDetails.filter((detail) => detail.id !== id),
    }));
  };

  const navigateToBbsPage = () => {
    navigate("/", { state: { setActiveMenu: "게시판", tabFlag: "투표목록" } });
  };

  const handleToggleDoubleCheck = () => {
    setToggledDoubleCheck(!isToggledDoubleCheck);
  };

  useEffect(() => {
    setVoteData((prevData) => {
      const newData = {
        ...prevData,
        startDate: formatDateWbar(startDate),
        endDate: formatDateWbar(endDate),
        enabled: true,
        multipleChoice: isToggledDoubleCheck,
        voteDetails: prevData.voteDetails,
      };
      return newData;
    });
  }, [startDate, endDate, isToggledDoubleCheck]);

  const regVoteButton = async () => {
    if (voteData.title === "") {
      Swal.fire("알림", "투표 제목을 입력해주세요.", "warning");
      return;
    }
    if (voteData.voteDetails.length === 0) {
      Swal.fire("알림", "투표 옵션을 입력해주세요.", "warning");
      return;
    }
    if (startDate === null || endDate === null) {
      Swal.fire("알림", "마감 일자를 정확히 입력해주세요.", "warning");
      return;
    }
    setVoteData({
      ...voteData,
      title: voteData.title,
    });
    try {
      const response = await axios.post(
        `${API_SERVER_URL}/create/${userId}`,
        {
          vote: {
            title: voteData.title,
            startDate: voteData.startDate,
            endDate: voteData.endDate,
            enabled: voteData.enabled,
            multipleChoice: voteData.multipleChoice,
          },
          voteDetails: voteData.voteDetails,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 201) {
        Swal.fire({
          icon: "success",
          title: "성공",
          text: "투표가 등록되었습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        }).then(() => {
          navigateToBbsPage();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "투표 등록 실패. 다시 시도해주세요.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    } catch (error) {
      console.error("Error Creating Votes:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "투표 등록 오류",
            text: responseData,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    }
  };

  const CustomDatePickerInput = forwardRef(({ value, onClick }, ref) => (
    <button className="custom-datepicker-input" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));

  return (
    <div className="bbs-content-container">
      <div className="bbs-vote-content-container" style={{ display: "flex", flexDirection: "column" }}>
        <div className="vote-header">
          <input type="text" name="title" value={voteData.title} onChange={handleChange} placeholder="새 투표를 만들어보세요." autoFocus />
        </div>
        <div className="vote-contents">
          <label>투표 옵션</label>
          <div className="voting-container">
            {options.length === 0 && (
              <ul className="vote-contents-align">
                {options.length < 5 && (
                  <li className="vote-add-button">
                    <FontAwesomeIcon className="icon-size icon-plus-background" onClick={addOption} icon={faSquarePlus} />
                  </li>
                )}
                <li className="vote-contents" style={{ width: "390px" }}></li>
              </ul>
            )}
            {options.map((option) => (
              <ul className="vote-contents-align">
                {options.length < 5 && (
                  <li className="vote-add-button">
                    <FontAwesomeIcon className="icon-size icon-plus-background" onClick={addOption} icon={faSquarePlus} />
                  </li>
                )}
                <li className="vote-contents-input" key={option.id}>
                  <input type="text" name="content" placeholder={option.placeholder} onChange={(e) => handleChange(e, option.id)} />
                </li>
                {options.length > 1 && (
                  <li className="vote-minus-button">
                    <FontAwesomeIcon className="icon-size icon-minus-background" onClick={() => removeOption(option.id)} icon={faSquareMinus} />
                  </li>
                )}
              </ul>
            ))}
          </div>
          <label style={{ textAlign: "start", width: "100%" }}>투표 설정</label>
          <div className="voting-settings">
            <div className="voting-settings-option" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div className="settings-option-fonts">
                <FontAwesomeIcon icon={faClock} />
                &nbsp;&nbsp;<span>마감일 설정</span>
              </div>
            </div>
            <div className="deadline-hidden-container">
              <div className="startDate-datepicker">
                <span>
                  <FontAwesomeIcon icon={faCalendarDays} />
                  &nbsp;시작
                </span>
                <DatePicker
                  name="startDate"
                  locale={ko}
                  selected={startDate}
                  dateFormat="yyyy-MM-dd"
                  onChange={(date) => setStartDate(date)}
                  customInput={<CustomDatePickerInput />}
                  minDate={new Date()}
                />
              </div>
              <span style={{ fontSize: "15px" }}>~</span>
              <div className="endDate-datepicker">
                <span>
                  <FontAwesomeIcon icon={faCalendarDays} />
                  &nbsp;마감
                </span>
                <DatePicker
                  name="endDate"
                  locale={ko}
                  selected={endDate}
                  dateFormat="yyyy-MM-dd"
                  onChange={(date) => setEndDate(date)}
                  customInput={<CustomDatePickerInput />}
                  minDate={new Date(startDate)}
                />
              </div>
            </div>
            <div className="voting-settings-option" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <div className="settings-option-fonts">
                <FontAwesomeIcon icon={faCheckDouble} />
                &nbsp;&nbsp;<span>복수 선택</span>
              </div>
              <div>
                <div className={`toggle-slider ${isToggledDoubleCheck ? "toggled" : ""}`} onClick={handleToggleDoubleCheck}>
                  <div className="slider"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="vote-footer">
          <button style={{ backgroundColor: "#333" }} onClick={regVoteButton}>
            저장
          </button>
          <button onClick={navigateToBbsPage}>취소</button>
        </div>
      </div>
    </div>
  );
}

export default BbsVote;
